import styled from 'styled-components';
import Typography from '../Typography';
import breakpoint from '../breakpoints';
import { Link as LinkRouter } from '@reach/router'

export const Background = styled.div`
  background: #000000;
  display: block;
`
export const Wrapper = styled.div`
  color: #FFF;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-around;
  padding: 0;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  justify-content: space-evenly;
  display: block;
  ${breakpoint('tablet', 'up')} {
    display: flex;
  }
`
export const Logo = styled.div`
  display: block;
  margin-bottom: 10px;
  width: 100%;
  ${breakpoint('tablet', 'up')} {
    margin-bottom: 0;
  }
  ${breakpoint('tablet', 'down')}{
    width: 60%;
  }
  img {
    margin-left: 50%;
    display: block;
    filter: brightness(0) invert(1);
  }
`
export const Copy = styled(Typography.BodySmall)`
  display: block;
  width: 55%;
  margin: 0 auto;
  ${breakpoint('tablet')} {
    margin: 0;
    width: 100%;
  }
`
export const Disclaimer = styled(Typography.BodySmall)`
  display: block;
  margin-left: -10px;
  ${breakpoint('tablet', 'up')} {
    margin-left: 0;
    flex-wrap: 0;
  }

  a {
    color: #FFF;
    margin-left: 0;
    text-decoration: none;
    display: inline-block;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const SiteMap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 50%;
  width: 41%;
  & > span {
    padding: 5px;
  }
  ${breakpoint('tablet')} {
    width: 60%;
    margin-left: 31%;
  }
`
export const SiteMapWrapper = styled.div`
  padding-top: 5px;
  height: 120px;
  width: 100%;
`

export const Portfolios = styled.div`
  width: 55%;
  margin: 0 auto;
  ${breakpoint('tablet')}{
    width: 100%;
    margin: 0;
  }
`

export const About = styled.div`

`

export const Title = styled.span`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
  font-weight: 900;
`
export const ListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding-right: 15px;
`
export const ListItem = styled.li`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
`

export const Link = styled(LinkRouter)`
  font-family: 'ToyotaType Book';
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.05em;
  color: #fff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const TopElement = styled.div`
  width: 100%;
  border-bottom: 1px solid #CCC;
  padding-top: 30px;
  padding-bottom: 20px;
  vertical-align: baseline;
  height: 35px;
`

export const BottomElement = styled.div`
  padding-top: 40px;
  height: 120px;
  width: 100%;
`
